import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IndicataScriptSpot } from '@ncg/data';
import { firstValueFrom } from 'rxjs';
import { IndicataService } from '../../core/indicata.service';
import { TrackingService } from '../../core/tracking.service';

@Component({
    selector: 'ncg-autoproff-script-spot',
    template: `
        <section class="container columns" [class.is-centered]="data.isCentered">
            <button type="button" class="button is-primary" (click)="onClick()">
                @if (trackingService.functionalConsentGiven() | async) {
                    {{ data.buttonText }}
                } @else {
                    {{ data.buttonDisabledText }}
                }
            </button>
        </section>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class IndicataScriptSpotComponent {
    public static ref = 'indicatascript';

    @Input()
    public data: IndicataScriptSpot;

    constructor(
        private readonly indicataService: IndicataService,
        public readonly trackingService: TrackingService
    ) {}

    public async onClick() {
        const hasConsent = await firstValueFrom(this.trackingService.functionalConsentGiven());
        if (hasConsent) {
            await this.indicataService.init();
        } else {
            this.trackingService.showCookieBanner();
        }
    }
}
